import { useState } from 'react';
import classNames from 'classnames/bind';
import { publicationTabs } from '../../../../../data/directory/publications/publications';
import PremiumStories from './PremiumStories';
import Tabs from '../../../../WatchlistComponents/WatchlistPageWrapper/Tabs';
import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const PremiumNewsContent = ({ whiteListId, classname, singlePremiumNews }) => {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = async (id) => {
    setActiveTab(id);
  };

  return (
    <div className={cx('premiumNewsContent')}>
      {!whiteListId && (
        <Tabs
          tabs={publicationTabs}
          activeTab={activeTab}
          onTabClick={handleTabClick}
          classname="publicationTabs"
        />
      )}
      <PremiumStories
        isMajorOnly={activeTab === 2}
        whiteListId={whiteListId}
        classname={classname}
        singlePremiumNews={singlePremiumNews}
      />
    </div>
  );
};

export default PremiumNewsContent;
